import { render, staticRenderFns } from "./OpenApp.vue?vue&type=template&id=42b3faa1&scoped=true"
import script from "./openapp.js?vue&type=script&lang=js&external"
export * from "./openapp.js?vue&type=script&lang=js&external"
import style0 from "./openapp.scss?vue&type=style&index=0&id=42b3faa1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3faa1",
  null
  
)

export default component.exports